
import {getWithDrawals} from '../api/getWithdrawals';
import {setWithdrawalsAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setWithdrawals = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getWithDrawals(params);
    
            if (data.status === 'success') {
                const getArrayMap = (value) => {
                    
                    const tmp = [];
                    if (value.length) {
                        for (let i = 0; i < value.length; i++) {
                            if ((i < value.length - 1) && +value[i].event_date === +value[i + 1].event_date)  {
                                tmp.push([{...value[i]}, {...value[i + 1]}])
                                i++;
                            } else {
                                tmp.push(value[i])
                            }
                        }
                    }   
                    return tmp
                }

                // const prev = getArrayMap(getState().withdrawalsMobile.withdrawals.data)
                // const withdrawals = [];
                // withdrawals.push(prev);

                // withdrawals.push(getArrayMap(data.data));
                dispatch(setWithdrawalsAction({
                    data: getArrayMap(data.data),
                    countPage: data.countPage
                }));       
                dispatch(setLoadingAction(false))    
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setWithdrawals
}